export default __webpack_public_path__ + "static/media/smog.805a4303.jpg";